export default {
  error: {
    error_occured: "Ein Fehler ist aufgetreten",
    not_found: "Die angeforderte Ressource wurde nicht gefunden.",
    reload_page: "Seite neu laden",
    back: "Zurückgehen",
    message: {
      profile_load_failed:
        "Ihr Profil konnte nicht geladen werden, einige Informationen werden möglicherweise ausgeblendet. Bitte laden Sie die Seite neu.",
      not_found: "Die angeforderte Seite wurde nicht gefunden!",
      unavailable: "Dienst nicht verfügbar!",
      not_authorized_title: "Zugriff verweigert",
      not_authorized: "Sie verfügen nicht über die erforderlichen Berechtigungen",
      file_not_authorized: "Sie sind nicht berechtigt, eine Datei herunterzuladen",
      unauthenticated: "Sie müssen sich authentifizieren, um auf diese Seite zuzugreifen",
      usurpation_error:
        "Sie agieren im Namen eines Kontos, das keinen Zugriff auf diesen Bereich hat. Bitte beenden Sie die Übernahme dieses Benutzers",
      usurpation_restore_lost:
        "Sie haben das übernommene Konto verlassen. Bitte melden Sie sich erneut an, um Ihre Sitzung wiederherzustellen.",
      session_lost: "Ihre Sitzung ist abgelaufen, bitte melden Sie sich erneut an",
    },
    go_back_to_home: "Zur Startseite zurückkehren",
    support_message:
      "Bei der Operation ist ein Fehler aufgetreten. Unsere Teams arbeiten daran, das Problem zu lösen. Vielen Dank für Ihr Verständnis.",
    sso_user_not_found: "Kein Studea-Konto entspricht diesem Benutzer. Bitte wenden Sie sich an Ihren Administrator.",
    sso_link_expired:
      "Ihr Anmeldelink ist nicht mehr gültig. Bitte melden Sie sich erneut über Ihren gewohnten Bereich an.",
  },
  warning: {
    title: "Achtung: ",
    login_attempts:
      "Sie haben noch {attempts} Versuche. Danach wird Ihr Zugang aus Sicherheitsgründen 5 Minuten lang gesperrt.",
    login_blocked:
      "Ihr Konto ist aufgrund mehrerer fehlgeschlagener Versuche vorübergehend gesperrt. Bitte warten Sie 5 Minuten, bevor Sie es erneut versuchen.",
  },
};
